<template>
    <modal body-class="communication-iframe-modal" :id="modalId" :title="`${subject}`" size="lg">
        <div>{{ message }}</div>
        <template #modal-footer="{ ok, cancel }">
            <div class="w-100">
                <b-button variant="primary" class="float-right accept-button ml-2" :disabled="false" @click="ok()">
                    OK
                </b-button>
                <b-button v-if="showMarkAsRead" variant="danger" class="float-right" @click="onDismiss()">
                    Mark As Read
                </b-button>
                <b-button variant="primary" v-if="href" class="float-left" @click="preformQuickAction()">{{
                    quickActionName
                }}</b-button>
            </div>
        </template>
    </modal>
</template>

<script>
    import Modal from '../generic/modal/modal.vue';
    import API from '../../api';
    import { NOTIFICATION_ENDPOINT } from '../../endpoints';
    import { mapMutations } from 'vuex';
    import { NOTIFICATION_DROPDOWN_MAX } from '../../constants';
    import { formatDistanceToNowStrict } from 'date-fns';

    export default {
        name: 'NotificationModal',
        props: {
            message: String,
            subject: String,
            date: String,
            modalId: String,
            notificationId: String,
            showMarkAsRead: Boolean,
            href: {
                type: String,
                default: '',
                required: false,
            },
        },
        components: {
            Modal,
        },
        computed: {
            dateComputed() {
                const value = `${formatDistanceToNowStrict(new Date(this.date))} ago`;
                return value ? value : '';
            },
            quickActionName() {
                if (this.href == '/app/notification/') {
                    return 'View All Notifications';
                } else if (this.href == '/app/subscription/billing/') {
                    return 'Manage Billing';
                } else if (this.href.includes('/app/reservation/edit/invoice/')) {
                    return 'View Invoice';
                } else if (this.href.includes('/app/work-orders/list/?work_order_id=')) {
                    return 'View Work Order';
                } else if (this.href.includes('/app/chat/')) {
                    return 'View in Unified Inbox';
                } else {
                    return 'View More';
                }
            },
        },
        methods: {
            ...mapMutations('header', ['setNotificationList']),
            async onDismiss() {
                this.$bvModal.hide(this.modalId);
                await API.patch(`${NOTIFICATION_ENDPOINT()}notifications_set_read/`, {
                    notification_id: this.notificationId,
                });
                const notificationList = await API.get(`${NOTIFICATION_ENDPOINT()}notifications/`, {
                    params: {
                        offset: 0,
                        limit: NOTIFICATION_DROPDOWN_MAX,
                        sort: 'date',
                        desc: true,
                        is_read: false,
                    },
                });
                this.setNotificationList(notificationList.data);
            },
            async preformQuickAction() {
                this.$bvModal.hide(this.modalId);
                window.location.href = this.href;
            },
        },
    };
</script>
